export class CustomFieldValidationError extends Error {
    constructor(message) {
        super(message);
    }
}
